export default function BulkEmailSummary({
  alreadySent,
  missingEmail,
  notApproved = [],
  eligible,
}) {
  return (
    <div>
      {notApproved.length > 0 && (
        <div className="mb-3 rounded-lg border border-palette-red-border bg-palette-red-soft p-3">
          <p className="text-sm font-semibold text-palette-red-text mb-1">
            ✗ {notApproved.length} practitioner
            {notApproved.length !== 1 ? "s" : ""} not approved (will not be sent):
          </p>
          <div className="max-h-28 overflow-y-auto">
            {notApproved.map((r) => (
              <div key={r.id} className="text-sm text-palette-red-heading py-0.5">
                {r.practitioner_name} ({r.practitioner_email})
              </div>
            ))}
          </div>
        </div>
      )}
      {alreadySent.length > 0 && (
        <div className="mb-3 rounded-lg border border-palette-indigo-border bg-palette-indigo-soft p-3">
          <p className="text-sm font-semibold text-palette-indigo-text mb-1">
            ✉ {alreadySent.length} practitioner
            {alreadySent.length !== 1 ? "s" : ""} already emailed (will be re-sent):
          </p>
          <div className="max-h-28 overflow-y-auto">
            {alreadySent.map((r) => (
              <div key={r.id} className="text-sm text-palette-indigo-heading py-0.5">
                {r.practitioner_name} ({r.practitioner_email})
              </div>
            ))}
          </div>
        </div>
      )}
      {missingEmail.length > 0 && (
        <div className="mb-3 rounded-lg border border-palette-amber-border bg-palette-amber-soft p-3">
          <p className="text-sm font-semibold text-palette-amber-text mb-1">
            ⚠ {missingEmail.length} practitioner
            {missingEmail.length !== 1 ? "s" : ""} missing email address:
          </p>
          <div className="max-h-28 overflow-y-auto">
            {missingEmail.map((r) => (
              <div key={r.id} className="text-sm text-palette-amber-heading py-0.5">
                {r.practitioner_name} ({r.clinic})
              </div>
            ))}
          </div>
          <p className="text-sm text-palette-amber-badge mt-1">
            These will be skipped. Cancel to update their profiles first.
          </p>
        </div>
      )}
      <p className="text-sm mb-2">
        Send associate fee PDFs to <strong>{eligible.length}</strong> practitioner
        {eligible.length !== 1 ? "s" : ""}?
      </p>
      <div className="max-h-48 overflow-y-auto rounded border border-palette-gray-divider bg-palette-gray-soft p-2">
        {eligible.map((r) => (
          <div key={r.id} className="flex items-center justify-between py-1 text-sm">
            <span className="font-medium">{r.practitioner_name}</span>
            <span className="text-palette-gray-secondary">{r.practitioner_email}</span>
          </div>
        ))}
      </div>
    </div>
  );
}
